import { IReward } from './IReward';
import { Reward } from './Reward';
import DebitPosTransactionTypes from '../DebitPosTransactionTypes';

export class PerPosTrxTypeFeeReductionReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.PerPosTrxTypeFeeReductionReward';

	public static readonly NAME: string = 'Per POS Transaction Type Fee Reduction';

	posTransactionType: string = DebitPosTransactionTypes.ALL.value;

	perPosTrxTypeFeeReductionAmount: number = 0;

	minimumTrxAmount: number = 0;

	constructor(reward?: IReward) {
	  super(PerPosTrxTypeFeeReductionReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.posTransactionType = (reward as any).posTransactionType;
	    this.perPosTrxTypeFeeReductionAmount = (reward as any).perPosTrxTypeFeeReductionAmount;
	    this.minimumTrxAmount = (reward as any).minimumTrxAmount;
	  }
	}

	getDescription(): string {
	  return `$${this.perPosTrxTypeFeeReductionAmount} fee reduction per ${this.posTransactionType} transaction $${this.minimumTrxAmount} or over`;
	}

	clone(): IReward {
	  const clone = new PerPosTrxTypeFeeReductionReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default PerPosTrxTypeFeeReductionReward;
